import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Grid,
  Typography,
  Box,
  Stack,
  Breadcrumbs,
  Link,
  useMediaQuery
} from '@mui/material';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CustomDivider from './CustomDivider';

function Conseil({ t }) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  const breadcrumbs = [
    <Link
      key="1"
      underline="hover"
      color="inherit"
      component={RouterLink}
      to="/Services"
    >
      {t('Breadcrumbs.service')}
    </Link>,
    <Typography key="2" color="text.primary" sx={{ color: '#AB0C18' }}>
      {t('Breadcrumbs.conseil')}
    </Typography>
  ];

  const bullets = [1, 2, 3].map((i) => (
    <Typography key={i} sx={{ mb: 2 }}>
      <span style={{ fontWeight: 'bold', color: '#AB0C18', fontSize: '20px' }}> • </span>
      {t(`Conseil.sous-titre1.bullet${i}`)}
    </Typography>
  ));

  const renderSection = (key, titleVariant = 'h5') => {
    const sectionTitle = t(`Conseil.${key}.titre`);
    const sectionDesc = t(`Conseil.${key}.description`);
    
    return (
      <>
        <Typography variant={titleVariant} sx={{ mb: 1, color: '#AB0C18' }}>
          {sectionTitle}
        </Typography>

        {sectionDesc !== `Conseil.${key}.description` && (
          <Typography sx={{ mb: 2 }}>{sectionDesc}</Typography>
        )}

        {[...Array(6).keys()].map(i => {
          const descKey = `description${i + 1}`;
          const descVal = t(`Conseil.${key}.${descKey}`);
          return descVal !== `Conseil.${key}.${descKey}` ? (
            <Typography key={descKey} sx={{ mb: 2 }}>
              {descVal}
            </Typography>
          ) : null;
        })}
      </>
    );
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: isMobile ? '20px' : '50px',
        paddingBottom: isMobile ? '30px' : '50px',
        mb: '20px'
      }}
    >
      <Box sx={{ width: 'calc(100% - 32px)', maxWidth: '900px', py: { xs: 3, md: 6 } }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#AB0C18' }}>
          {t('Conseil.titre')}
        </Typography>

        <CustomDivider sx={{ mb: 3 }} />

        <Stack spacing={2} sx={{ mb: 2 }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" sx={{ color: '#AB0C18' }} />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>

        <Typography variant="h5" sx={{ mb: 1, color: '#AB0C18' }}>
          {t('Conseil.sous-titre1.titre')}
        </Typography>
        <Typography sx={{ mb: 2 }}>
          {t('Conseil.sous-titre1.description')}
        </Typography>
        {bullets}

        {renderSection('sous-titre2', 'subtitle1')}
        {renderSection('sous-titre3', 'subtitle1')}
        {renderSection('sous-titre4', 'subtitle1')}
        {renderSection('sous-titre5')}
        {renderSection('sous-titre6')}
        {renderSection('sous-titre7')}
      </Box>
    </Grid>
  );
}

export default withTranslation()(Conseil);
